import { useEffect, useState } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import { get } from "../Libraries/Ajax/HttpService";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker, Space, Badge } from "antd";
// import { useHistory } from 'react-router-dom';
import { Card, Table } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Tooltip,
  LineChart,
  ResponsiveContainer,
} from "recharts";
import { Collapse, theme } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useRef } from "react";
import Highlighter from "react-highlight-words";
import { useNavigate } from "react-router-dom";
import { useDistrict } from "../utils/DistrictContext";
const { Panel } = Collapse;

function Healthstatus() {
  const [reverse, setReverse] = useState(false);
  const [reversetwo, setReversetwo] = useState(false);
  const [reversethree, setReversethree] = useState(false);
  const [loading, setloading] = useState(true);
  const [selected, setSelected] = useState("week");

  const [datas, setdatas] = useState([]);
  const [data, setdata] = useState([]);
  const [datadevice, setdatadevice] = useState([]);
  const [dataoutlier, setDataoutlier] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const selectedDistrict = useDistrict();
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilter: (value, record) => {
      const val = record[dataIndex] ?? "";
      return String(val).toLowerCase().includes(value.toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const { RangePicker } = DatePicker;
  // let history = useHistory();
  const navigate = useNavigate();
  // const { token } = theme.useToken();
  const panelStyle = {
    marginBottom: 24,
    // background: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    border: "none",
  };
  const columns = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "10%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },
    {
      title: "Category",
      dataIndex: "name",
      key: "name",
      width: "11%",
      ...getColumnSearchProps("name", "Category"),
    },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "10%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "8%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },

    {
      title: "Previous Week",
      // dataIndex: 'pre_week',
      key: "pre_week",
      width: "14%",

      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.pre_week_range}</a>
          <br />
          <a>{record.pre_flow}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "Current Week",
      // dataIndex: 'pre_week',
      key: "week",
      width: "14%",

      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.week_range}</a>
          <br />
          <a>{record.flow}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },

    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },
    // {
    //     title: 'Message',
    //     dataIndex: 'encoer_comm_msg',
    //     key: 'encoer_comm_msg',

    //     width: '17%',
    //     render: (_, record) => (<> {record.encoer_comm_msg ? <div className="circleredbadge"><a>{record.encoer_comm_msg}</a><br /></div> : ""}<br />
    //         {record.last_comm_msg ? <div className="circleredbadge"><a>{record.last_comm_msg}</a><br /></div> : ""}<br />
    //         {record.end_tamper_msg ? <div className="circleredbadge"><a>{record.end_tamper_msg}</a></div> : ""} </>)

    // },
    {
      title: "Message",
      dataIndex: "encode_error_msg",
      key: "encode_error_msg",

      width: "17%",
      render: (_, record) => (
        <>
          {" "}
          {record.encode_error_msg ? (
            <div className="circleredbadge">
              <a>{record.encode_error_msg}</a>
              <br />
            </div>
          ) : (
            ""
          )}
          <br />
          {record.last_comm_msg ? (
            <div className="circleredbadge">
              <a>{record.last_comm_msg}</a>
              <br />
            </div>
          ) : (
            ""
          )}
          <br />
          {record.end_tamper_msg ? (
            <div className="circleredbadge">
              <a>{record.end_tamper_msg}</a>
            </div>
          ) : (
            ""
          )}{" "}
        </>
      ),
    },
  ];

  const columnss = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "10%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },
    {
      title: "Category",
      dataIndex: "name",
      key: "name",
      width: "11%",
      ...getColumnSearchProps("name", "Category"),
    },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "10%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "8%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },

    {
      title: "Previous Week",
      // dataIndex: 'pre_week',
      key: "pre_week",
      width: "14%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.pre_week_range}</a>
          <br />
          <a>{record.pre_flow}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "Current Week",
      // dataIndex: 'pre_week',
      key: "week",
      width: "14%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.week_range}</a>
          <br />
          <a>{record.flow}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },

    // {
    //     title: 'Message',
    //     dataIndex: 'bat_stat_msg',
    //     key: 'bat_stat_msg',
    //     width: '17%',
    //     render: (_, record) => (<> {record.bat_stat_msg ? <div className="circleredbadge"><a>{record.bat_stat_msg}</a></div> : ""}
    //         {record.signal_strength_msg ? <div className="circleredbadge mt-2"><a>{record.signal_strength_msg}</a></div> : ""}
    //         {record.end_tamper_msg ? <div className="circleredbadge mt-2"><a>{record.end_tamper_msg}</a></div> : ""} </>)

    // },
    {
      title: "Message",
      dataIndex: "battery_status_msg",
      key: "battery_status_msg",
      width: "17%",
      render: (_, record) => (
        <>
          {" "}
          {record.battery_status_msg ? (
            <div className="circleredbadge">
              <a>{record.battery_status_msg}</a>
            </div>
          ) : (
            ""
          )}
          {record.signal_msg ? (
            <div className="circleredbadge mt-2">
              <a>{record.signal_msg}</a>
            </div>
          ) : (
            ""
          )}
          {record.bad_tamper_msg ? (
            <div className="circleredbadge mt-2">
              <a>{record.bad_tamper_msg}</a>
            </div>
          ) : (
            ""
          )}{" "}
        </>
      ),
    },
  ];
  const columnoutlier = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "20%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },
    {
      title: "Category",
      dataIndex: "name",
      key: "name",
      width: "20%",
      ...getColumnSearchProps("name", "Category"),
    },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "30%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "10%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },

    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },
    {
      title: "Count",
      key: "include_count",
      dataIndex: "include_count",
      width: "15%",
      sorter: (a, b) => a.include_count - b.include_count,
      render: (_, record) => (
        <>
          <a>{record.include_count}</a>
          <br />
        </>
      ),
    },
    {
      title: "Average Flow",
      key: "avg",
      dataIndex: "avg",
      width: "15%",
      sorter: (a, b) => a.avg - b.avg,
      render: (_, record) => (
        <>
          <a>{Math.round(record.avg)}</a>
          <br />
        </>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const onMouseClick = (event) => {
    setSelected(event.target.value);
    console.log(selected);
  };

  const onTableClick = (event) => {
    setReverse(!reverse);
  };

  const onTabletwoClick = (event) => {
    setReversetwo(!reversetwo);
  };
  const onTablethreeClick = (event) => {
    setReversethree(!reversethree);
  };
  const onRedirection = (event) => {
    // history.push('/dashboard');
    navigate("/dashboard");
  };

  // useEffect(() => {
  //     setloading(true);
  //     get(
  //         `apis/bad_device_list`
  //     )
  //         .then(res => {

  //             setdatadevice(res.data.data.device_data.map(row => ({ location_city: row.location_city, register_number: row.register_number,signal_strength_msg: row.signal_strength_msg, bat_stat_msg: row.bat_stat_msg, end_tamper_msg: row.end_tamper_msg, location_state: row.location_state, location_zip: row.location_zip, week_range: row.week_range, unit: row.unit, account_id: row.account_id, week: row.week, account: row.account, flow_pre_week: row.flow_pre_week, pre_week_range: row.pre_week_range, meter_id: row.meter_id, meter_type: row.meter_type, sa_agreement: row.sa_agreement, location_address_line1: row.location_address_line1, flow_this_week: row.flow_this_week, location_address_line2: row.location_address_line2 })));
  //             setdatas(res.data.data.communication_data.map(row => ({ location_city: row.location_city,register_number: row.register_number, last_comm_msg: row.last_comm_msg, encoer_comm_msg: row.encoer_comm_msg, location_state: row.location_state, location_zip: row.location_zip, week_range: row.week_range, unit: row.unit, account_id: row.account_id, week: row.week, account: row.account, flow_pre_week: row.flow_pre_week, pre_week_range: row.pre_week_range, meter_id: row.meter_id, meter_type: row.meter_type, sa_agreement: row.sa_agreement, location_address_line1: row.location_address_line1, location_address_line2: row.location_address_line2, flow_this_week: row.flow_this_week })));
  //             console.log("system", res.data.data.meters);
  //             setDataoutlier(res.data.data.outlier_data.map(row => ({ location_city: row.location_city, register_number: row.register_number, location_state: row.location_state, location_zip: row.location_zip, unit: row.unit, account_id: row.account_id, account: row.account, include_count: row.include_count, avg_flow: row.avg_flow, meter_id: row.meter_id, calss_code: row.calss_code, sa_agreement: row.sa_agreement, location_address_line1: row.location_address_line1, location_address_line2: row.location_address_line2 })));
  //             setloading(false);

  //         });
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true);

        const response = await get("apis/system_battery");
        const apiData = response?.data?.data?.data || {};

        setdatadevice(apiData?.device_data || []);
        setdatas(apiData?.communication_data || []);
        setDataoutlier(apiData?.outlier_data || []);

        setloading(false);
      } catch (error) {
        console.error("Error fetching system battery data:", error);
      } finally {
        setloading(false);
      }
    };
    fetchData();
  }, [selectedDistrict?.selectedDistrict]);

  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div className="bottom-layout tableLayout mt-0">
          <Card bordered={false}>
            <Collapse
              // defaultActiveKey={['1']}
              bordered={false}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
              // style={{
              //     background: token.colorBgContainer,
              // }}
              onChange={onChange}
              className="selectAccordian"
            >
              <Panel header="Data Status" key="1">
                <p>
                  <Table
                    columns={columnoutlier}
                    dataSource={dataoutlier}
                    loading={loading}
                    className="styleRemove outliers-sty"
                    pagination={{
                      defaultPageSize: 20, // Set your default pagination size here
                      pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                    }}
                    columnWidth={10}
                    scroll={{
                      x: 800,
                      y: 580,
                    }}
                  />
                </p>
              </Panel>
              <Panel header=" Device Status" key="2">
                <p>
                  <Table
                    columns={columnss}
                    loading={loading}
                    dataSource={datadevice}
                    className="styleRemove outliers-sty"
                    pagination={{
                      defaultPageSize: 20, // Set your default pagination size here
                      pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                    }}
                    columnWidth={10}
                    scroll={{
                      x: 800,
                      y: 580,
                    }}
                    locale={{ emptyText: "No data" }}
                  />
                </p>
              </Panel>
              <Panel header="Communication Status" key="3">
                <p>
                  <Table
                    columns={columns}
                    loading={loading}
                    dataSource={datas}
                    className="styleRemove outliers-sty"
                    pagination={{
                      defaultPageSize: 20, // Set your default pagination size here
                      pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                    }}
                    columnWidth={10}
                    scroll={{
                      x: 800,
                      y: 580,
                    }}
                    locale={{ emptyText: "No data" }}
                  />
                </p>
              </Panel>
            </Collapse>
          </Card>
        </div>
      </Main>
    </>
  );
}

export default Healthstatus;
